// ==============================================================
// web socket functions
import { wsOpen, wsClose, wsSubscribe } from "@/modules/wsNotify";
import store from "@/store";

// ==============================================================
// ==============================================================
const chApp = "ORDERPAD:";

// ==============================================================
export function openWebSocket() {
  wsOpen(subscribe);
}

export function closeWebSocket() {
  wsClose();
}

async function subscribe() {
  if (store.getters.storeCompanyCode) {
    // await sleep(10);
    let wsChannel = chApp + store.getters.storeCompanyCode;
    //console.log("ws channel:", wsChannel);
    wsSubscribe(wsChannel, hdAppMsg1);
  }

  if (store.getters.storeCompanyCode && store.state.Order.order.tableID) {
    // await sleep(10);
    let wsChannel = chApp + store.getters.storeCompanyCode + ":" + store.state.Order.order.tableID;
    //console.log("ws channel:", wsChannel);
    wsSubscribe(wsChannel, hdAppMsg2);
  }
}

// ==============================================================
function hdAppMsg1(data) {
  console.log("hdAppMsg1", data);

  if (data?.inventory) {
    data.inventory.forEach(e => {
      if (e.type == "i") {
        let item = store.state.Pad.allItems.find(x => x.ID == e.id);
        if (item) {
          item.qty = e.qty;
          item.soldout = e.soldout;
        }
      }
    });
  }
}
// ==============================================================
function hdAppMsg2(data) {
  console.log("hdAppMsg2", data);

  let numOfGuests = data?.numberOfGuests;
  if (numOfGuests) {
    store.commit("PAD_NUM_OF_GUESTS", numOfGuests);
  }

  let order = data?.order;
  if (order) {
    store.commit("PAD_ORDER", order);
  }
}
// ==============================================================
